import Utils from "../../Shared/Utils";
import UIManager from "../../Shared/UIManager";
import CQRCode from "../../Shared/CQRCode";
import NetworkLogic from "../../Shared/NetworkLogic";
import Constant from "../../Shared/Constant";
import { Global } from "../../Shared/Global";
import TaskData from "./TaskData";
import SDKManager from "../../Shared/SDKManager";
import SHORT_BU66_SDK from "../../Shared/SHORT_BU66_SDK";
import AudioManager from "../../Shared/AudioManager";
import Player from "../../Models/Player";
const i18n = require('LanguageData');




const { ccclass, property } = cc._decorator;

@ccclass
export default class TaskShareLayer extends cc.Component {
    @property([cc.SpriteFrame])
    btnSpArr: cc.SpriteFrame[] = [];
    @property(cc.Prefab)
    pfbShareToWechat: cc.Prefab = null;
    @property(cc.Prefab)
    pfbSubmit: cc.Prefab = null;
    @property(cc.Label)
    shareText: cc.Label = null;
    @property(cc.Label)
    labBottomLeft: cc.Label = null;//desclab
    @property(cc.Label)
    labState: cc.Label = null;//状态lab
    @property([cc.Sprite])
    spArr: cc.Sprite[] = [];//6张小图
    @property([cc.Sprite])
    spArrBig: cc.Sprite[] = [];//6d图
    @property(cc.Button)
    btnSubmit: cc.Button = null;
    @property(cc.Button)
    btnCopy: cc.Button = null;
    @property(cc.Button)
    btnSave: cc.Button = null;
    @property(cc.Button)
    btnShare: cc.Button = null;
    @property(cc.Sprite)
    spShareTutorial: cc.Sprite = null;
    @property(cc.Sprite)
    spUploadImgTutorial: cc.Sprite = null;
    @property(cc.Node)
    nodeImageShare: cc.Node = null;
    @property(cc.Node)
    nodeImageSubmit: cc.Node = null;
    @property(cc.Node)
    nodeIntroduce: cc.Node = null;
    //二维码
    @property(CQRCode)
    QRCode: CQRCode = null;//二维码
    //二维码
    @property(CQRCode)
    QRCode1: CQRCode = null;//二维码
    data = null;

    strShare = ""
    codeAddress = null;  //地址

    start() {
        cc.director.on(Global.UserEvent.UpdateShareTaskBtn, this.updateBtn, this)

    }

    onDestroy(): void {
        cc.director.off(Global.UserEvent.UpdateShareTaskBtn, this.updateBtn, this)

    }

    updateBtn(rec) {
        let taskHandleStatus = 0;
        cc.log("===更新按钮");
        this.btnSubmit.node.getChildByName("labName").getComponent(cc.Label).string = TaskData.getBtnType(taskHandleStatus);
        this.btnSubmit.node.getComponent(cc.Sprite).spriteFrame = this.btnSpArr[taskHandleStatus + 1]
        this.btnSubmit.interactable = TaskData.getBtnInteractable(taskHandleStatus)
        this.labState.string = rec // TaskData.getStateStr(taskHandleStatus);
    }
    /**
     agentCode: "dg8n75itm9jz"
     auditMoney: 1
     descText: "aDASD"
     promoteTheAddress: "http://ygrnapp.fanyirong.com/?channelCode=daili04"
     shareDesc: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     shareImg: (6) ["http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"]
     shareMoney: 10
     shareSwitch: "0"
     shareText: "321312312,2321312,213123"
     shareTutorial: "http://api.fanyirong.com:8080/group1/zonghe/9aa74e1e0cd46823e19b2d9c9a7e61ff.png"
     taskHandleStatus: 0
     uploadImgTutorial: "http://api.
     * @param data
     */
    async updateUI(data) {
        this.data = data;

        let promoteTheAddress = data.promoteTheAddress;
        this.codeAddress = promoteTheAddress;


        let textArr = data.shareText.split("&");
        let tempNum = Utils.getRandomNum(0, textArr.length - 1);
        let shareText = textArr[tempNum];
        this.strShare = shareText;
        let date = new Date();
        let getDate = date.getDate().toString();
        let dM = this._getTime();
        this.shareText.string = shareText + "\n" + dM + "\n" + promoteTheAddress;
        //生成二维码
        this.QRCode.string = promoteTheAddress;
        this.QRCode1.string = promoteTheAddress;


        this.btnSubmit.node.getChildByName("labName").getComponent(cc.Label).string = TaskData.getBtnType1(data.taskHandleStatus);
        this.btnSubmit.node.getComponent(cc.Sprite).spriteFrame = this.btnSpArr[data.taskHandleStatus + 1]
        this.btnSubmit.interactable = TaskData.getBtnInteractable(data.taskHandleStatus);
        this.labBottomLeft.string = data.auditText;
        this.labState.string = data.descText //TaskData.getStateStr(data.taskHandleStatus);

        let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
        let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
        let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
        if (data.taskHandleStatus != -1) {
            cc.sys.localStorage.setItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"), getDate.toString() + Player.getPy("userID"))
            cc.director.emit(Global.UserEvent.UpdateShareRedPoint)
        }
        let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
        if (!storageCopy || storageCopy != "copy" + Player.getPy("userID")) {
            this.btnCopy.node.getChildByName("redPoint").active = true;
        }
        if (!storageSave || storageSave != "save" + Player.getPy("userID")) {
            this.btnSave.node.getChildByName("redPoint").active = true;
        }
        if (!storageShare || storageShare != "share" + Player.getPy("userID")) {
            this.btnShare.node.getChildByName("redPoint").active = true;
        }
        if (!storageSubmit || storageSubmit != getDate.toString() + Player.getPy("userID")) {
            this.btnSubmit.node.getChildByName("redPoint").active = true;
        }

        cc.loader.load(data.shareTutorial, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(this.spShareTutorial)) {
                    this.spShareTutorial.spriteFrame = new cc.SpriteFrame(texture);
                    this.nodeImageShare.getChildByName("btnImage").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
                }
            } else {
                cc.log("===加载图片spAgent错误");
            }
        }.bind(this));

        cc.loader.load(data.uploadImgTutorial, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(this.spUploadImgTutorial)) {
                    this.spUploadImgTutorial.spriteFrame = new cc.SpriteFrame(texture);
                    this.nodeImageSubmit.getChildByName("btnImage").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
                }
            } else {
                cc.log("===加载图片spAgent错误");
            }
        }.bind(this));
        this.spArr[0].node.parent.active = true;
        for (let i = 0; i < data.shareImg.length; i++) {
            cc.loader.load(data.shareImg[i], function (err, texture) {
                if (!err && this.node) {
                    if (cc.isValid(this.spArr[i])) {
                        this.spArr[i].spriteFrame = new cc.SpriteFrame(texture);
                        this.spArrBig[i].spriteFrame = new cc.SpriteFrame(texture);
                    }
                } else {
                    cc.log("===加载图片spAgent错误");
                }
            }.bind(this))
        }
    }

    _getTime() {
        let date = new Date();
        let month = (date.getMonth() + 1).toString();
        let getDate = date.getDate().toString();
        if (month.length === 1) {
            month = "0" + month;
        }
        if (getDate.length === 1) {
            getDate = "0" + getDate;
        }
        cc.log("====获取时间：", month + getDate);
        return month + getDate;
    }

    _saveImage(node, i): Promise<any> {
        return new Promise<any>(resolve => {
            Utils.saveNodeImageToAlbum(node, "QRCode" + i + ".png", function (success) {
                resolve(success);
            });

        })
    }

    onBtnCopy(event, param) {
        AudioManager.playSound("button");
        this.shareText.string = this.strShare + "\n" + this._getTime() + "\n" + this.codeAddress;
        Utils.copyText(this.shareText.string);
        UIManager.showToastUI(i18n.t('share_text.copy_succ'))
        this.btnCopy.node.getChildByName("redPoint").active = false;
        cc.sys.localStorage.setItem(Global.localStorageId.TaskCopy + Player.getPy("userID"), "copy" + Player.getPy("userID"))
        cc.director.emit(Global.UserEvent.UpdateShareRedPoint)
    }

    async onBtnSaveImage(event, param) {
        AudioManager.playSound("button")
        this.btnSave.node.getChildByName("redPoint").active = false;
        cc.sys.localStorage.setItem(Global.localStorageId.TaskSave + Player.getPy("userID"), "save" + Player.getPy("userID"))
        cc.director.emit(Global.UserEvent.UpdateShareRedPoint)

        for (let i = 0; i < this.spArr.length; i++) {
            if (i === this.spArr.length - 1) {
                Utils.saveNodeImageToAlbum(this.spArrBig[i].node, "QRCode" + i + ".png", function (success) {
                    if (success) {

                        UIManager.showToastUI(i18n.t('share_text.save_img_succ'), Global.ToastType.OK)
                    } else {
                        UIManager.showTipUI(i18n.t('share_text.save_err'))
                    }
                }.bind(this));
            } else {
                Utils.saveNodeImageToAlbum(this.spArrBig[i].node, "QRCode" + i + ".png");
                //await this._saveImage(this.spArrBig[i].node, i);
            }
        }
    }

    onBtnShare(event, param) {
        AudioManager.playSound("button")

        this.btnShare.node.getChildByName("redPoint").active = false;
        cc.sys.localStorage.setItem(Global.localStorageId.TaskShare + Player.getPy("userID"), "share" + Player.getPy("userID"))
        cc.director.emit(Global.UserEvent.UpdateShareRedPoint)
        this.nodeIntroduce.active = true;
        this.nodeIntroduce.getComponent("TaskShareIntroduce").updateUI(this.data.titleImg);
    }

    onBtnSubmit(event, param) {
        AudioManager.playSound("button")
        let pfb = cc.instantiate(this.pfbSubmit);
        pfb.parent = this.node.parent;
        this.btnSubmit.node.getChildByName("redPoint").active = false;
        let date = new Date();
        cc.sys.localStorage.setItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"), date.getDate().toString() + Player.getPy("userID"));
        cc.director.emit(Global.UserEvent.UpdateShareRedPoint)
    }

    onBtnImageShare(event, param) {
        AudioManager.playSound("button")
        this.nodeImageShare.active = true;

    }
    onBtnImageSubmit(event, param) {
        AudioManager.playSound("button")
        this.nodeImageSubmit.active = true;
    }

    onBtnBigImageShare(event, param) {
        AudioManager.playSound("button")
        this.nodeImageShare.active = false;
    }
    onBtnBigImageSubmit(event, param) {
        AudioManager.playSound("button")
        this.nodeImageSubmit.active = false;

    }



    onBtnClose() {
        AudioManager.playSound("close")
        this.node.destroy();
    }
}
